module.exports = "<div class=\"container-fluid\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-3\">\n        <div class=\"nav d-flex flex-column\">\n          <div class=\"nav-item d-flex justify-content-between\" [ngClass]=\"accountsActive ? 'active' : ''\" (click)=\"accountsActive = true\">\n            <p>Accounts</p>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-9\">\n        <app-accounts *ngIf=\"accountsActive\"></app-accounts>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/manage.component.html
// module id = ./src/app/manage/manage.component.html
// module chunks = main